"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexedBy = void 0;
const defaultOptions = {
    collide: false
};
/**
 * Returns an object indexed by the given field from the array of objects.
 *
 * @param key The key to index by.
 * @param array The array of Objects.
 * @param options See `IndexedByOptions`
 */
exports.indexedBy = (key, array, options) => {
    const o = Object.assign({}, defaultOptions, options);
    return array.reduce((indexedArray, value) => {
        if (!o.collide && indexedArray[value[key]])
            throw new Error(`Key ${value[key]} occurs more than once`);
        indexedArray[value[key]] = value;
        return indexedArray;
    }, {});
};
//# sourceMappingURL=indexed-by.js.map